import React from "react";
import { Col, Row } from "react-bootstrap";
import DonutsCard from "./sub-components/donutCards";
import { useNavigate } from "react-router-dom";
import { ToRepairingSkeleton } from "./sub-components/skeleton";

const ToRepairing = ({
  currentPage,
  setCurrentPage,
  allRepairingList,
  isRepairingLoading,
}) => {
  const navigate = useNavigate();

  const handleChangePage = (event) => {
    setCurrentPage((prev) => prev + 1);
  };

  return (
    <>
      <p className="secondHeader">Repairing</p>
      <Row>
        {isRepairingLoading ? (
          <ToRepairingSkeleton />
        ) : allRepairingList?.users === undefined ||
          allRepairingList?.users === null ||
          allRepairingList?.users?.length === 0 ||
          !allRepairingList?.users ? (
          <>
            <img
              alt="No data found"
              src={"no-data.gif"}
              style={{
                width: "200px",
                display: "block",
                margin: "0 auto",
                objectFit: "contain",
              }}
            />
          </>
        ) : (
          <>
            {allRepairingList?.users?.map((user, i) => (
              <Col
                xl={4}
                xxl={4}
                lg={4}
                md={6}
                xs={12}
                sm={12}
                key={i}
                onClick={() => {
                  navigate("/repairing/details-view", { state: user });
                }}
                style={{
                  cursor: "pointer",
                }}
              >
                <DonutsCard
                  key={i}
                  left={"Daily Average"}
                  last={"High Score"}
                  user={user}
                />
              </Col>
            ))}
          </>
        )}
      </Row>
      {allRepairingList?.users?.length === 0 ||
        (allRepairingList?.users?.length !== allRepairingList?.totalCount && (
          <p
            className="secondHeader"
            style={{
              cursor: "pointer",
            }}
            onClick={handleChangePage}
          >
            Load More
          </p>
        ))}
    </>
  );
};

export default ToRepairing;
// checked
